import ContactConfirm from "./ContactConfirm.vue";
import ContactEnd from "./ContactEnd.vue";
import ContactStart from "./ContactStart.vue";
import SerialConfirm from "./SerialConfirm.vue";
import SerialEnd from "./SerialEnd.vue";
import SerialStart from "./SerialStart.vue";
import RegistrationStart from "./RegistrationStart.vue";
import RegistrationConfirm from "./RegistrationConfirm.vue";
import Order from "./Order.vue";
import OrderConfirm from "./OrderConfirm.vue";
import RegistrationError from "./RegistrationError";
import Delivery from "./Delivery";
import DeliveryConfirm from "./DeliveryConfirm";
import DeliveryEnd from "./DeliveryEnd";
import Index from "./Index.vue";
import QA from "./QA.vue";
import ProductDetail from "./ProductDetail.vue";

export default {
  routes: [
    {
      path: "/admission",
      component: Index,
    },
    {
      path: "/contact",
      component: ContactStart,
    },
    {
      path: "/contact/confirm",
      component: ContactConfirm,
    },
    {
      path: "/contact/end",
      component: ContactEnd,
    },
    {
      path: "/serial",
      component: SerialStart,
    },
    {
      path: "/serial/confirm",
      component: SerialConfirm,
    },
    {
      path: "/serial/end",
      component: SerialEnd,
    },
    {
      path: "/registration/:uux",
      component: RegistrationStart,
    },
    {
      path: "/registration",
      component: RegistrationStart,
    },
    {
      path: "/registration/confirm",
      component: RegistrationConfirm,
    },
    {
      path: "/registration/order",
      component: Order,
    },
    {
      path: "/registration/order/confirm",
      component: OrderConfirm,
    },
    {
      path: "/registration/delivery",
      component: Delivery,
    },
    {
      path: "/registration/delivery/confirm",
      component: DeliveryConfirm,
    },
    {
      path: "/registration/delivery/end",
      component: DeliveryEnd,
    },
    {
      path: "/registration/error",
      component: RegistrationError,
    },
    {
      path: "/registration/qa",
      component: QA,
    },
    {
      path: "/registration/products/:productNo",
      component: ProductDetail,
    },
  ],
};
